import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Carousel,
  Form,
  Button,
  Accordion,
} from "react-bootstrap";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postEnquiry } from "../store/slices/tourpackage";

import {
  getcarrentalPackageList,
  carPackagePrice,
} from "../store/slices/carrentalpackage";

import HTMLRenderer from "../Component/htmlrender";
import enquiryheadimg from "../assets/img/modal-back.jpg";
import Navbarsticky from "./NavbarSticky";
import { nameregex, emailregex, mobileregex } from "../utils/helpers/regex";
import { Modal } from "react-bootstrap";

export default function CarPackageDetails() {
  const today = new Date().toISOString().split("T")[0];
  const { slug } = useParams();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const [needEntryTicket, setNeedEntryTicket] = useState(false);

  const [isloading, setisLoading] = useState(false);
  const [packageId, setPackageId] = useState("");
  const [packageName, setpackageName] = useState("");
  const [duration, setDuration] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [inclusive, setInclusive] = useState("");
  const [exclusive, setExclusive] = useState("");
  const [tourIternary, settourIternary] = useState([]);
  const [vehicleDetails, setvehicleDetails] = useState([]);
  const [places, setPlaces] = useState([]);
  const [newlimit, setnewlimit] = useState(0);

  const [date, setDate] = useState("");
  const [showEnquiry, setShowEnquiry] = useState(false);

  const [formData, setFormData] = useState({
    packageId: "",
    adultCount: 0,
    childCount: 0,
  });
  const [ages, setAges] = useState([]);
  const [packagepriceData, setpackagepriceData] = useState(null);
  const [priceerrors, setpriceErrors] = useState({});
  const [showPrice, setShowPrice] = useState(false);
  const [ageError, setAgeError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setcontactNumber] = useState("");
  const [adult, setAdult] = useState("");
  const [childwithbed, setchildwithbed] = useState("");
  const [childwithoutbed, setchildwithoutbed] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchPackage = async () => {
      setisLoading(true);
      try {
        const res = await dispatch(getcarrentalPackageList({ slug })).unwrap();
        const pkg = res?.carrentalpackages?.packageData?.[0];

        setpackageName(pkg.packageName);
        setDuration(pkg.duration);
        setDescription(pkg.description);
        setImages(pkg.images || []);
        setInclusive(pkg.inclusive);
        setExclusive(pkg.exclusive);
        settourIternary(pkg.iternary || []);
        setvehicleDetails(pkg.packages || []);
        setPlaces(pkg.places || []);
        setPackageId(pkg._id);
        setnewlimit(pkg.upperLimit);

        setFormData((p) => ({ ...p, packageId: pkg._id }));
      } catch (err) {
        console.error(err);
      } finally {
        setisLoading(false);
      }
    };
    fetchPackage();
  }, [dispatch, slug]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };
    let sanitizedVal = adult;
    switch (name) {
      case "name":
        setName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid name"
            : "";
        break;

      case "email":
        setEmail(value);
        validationErrors[name] =
          value.trim() === "" || !emailregex.test(value)
            ? "Please enter valid email"
            : "";
        break;

      case "contactNumber":
        sanitizedVal = value.replace(/\D/g, "").slice(0, 10);
        setcontactNumber(sanitizedVal);
        validationErrors[name] =
          value.trim() === "" || !mobileregex.test(value)
            ? "Please enter valid mobile number"
            : "";
        break;

      case "adult":
        sanitizedVal = value.replace(/\D/g, "").slice(0, 2);
        setAdult(sanitizedVal);
        validationErrors[name] =
          sanitizedVal === "" ? "Please enter valid value" : "";
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const submitenquiry = async (e) => {
    e.preventDefault();

    if (!validateModalForm()) return;
    setIsSubmitting(true);

    try {
      await dispatch(
        postEnquiry({
          name,
          email,
          contactNumber,
          adult,
          childCount: formData.childCount, //  ONLY childCount
          enquiryFor: "Travel Package",
          travelpackageId: packageId,
          entryFee: needEntryTicket, //  true / false
        }),
      ).unwrap();

      alert("Enquiry submitted successfully");
      closeModal();
    } catch (err) {
      alert(err.message || "Failed to submit enquiry");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePackageInputChange = async (name, value) => {
    const intValue = value === "" ? "" : parseInt(value, 10);
    setpackagepriceData(null);
    if (intValue < 0 || isNaN(intValue)) {
      setpriceErrors((prev) => ({
        ...prev,
        [name]: "Value must be a non-negative integer.",
      }));
      return;
    }

    const updatedData = {
      ...formData,
      packageId,
      [name]: intValue,
    };

    setFormData(updatedData);
    if (name === "childCount") {
      const newAges = [...ages];
      if (intValue > ages.length) {
        setAges([...newAges, ...Array(intValue - newAges.length).fill("")]);
      } else {
        setAges(newAges.slice(0, intValue));
      }
    }
  };
  const handleAgeChange = (index, value) => {
    const updatedAges = [...ages];
    updatedAges[index] = value;
    setAges(updatedAges);

    setShowPrice(false);
    setpackagepriceData(null);
  };
  useEffect(() => {
    const totalPax = formData.adultCount + formData.childCount;

    if (totalPax > newlimit) {
      setpriceErrors((prev) => ({
        ...prev,
        total: `The total pax cannot exceed ${newlimit}`,
      }));
    } else {
      setpriceErrors((prev) => ({
        ...prev,
        total: "",
      }));
    }
  }, [formData.adultCount, formData.childCount, newlimit]);

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Check this page",
          text: "Hey, look at this!",
          url: window.location.href,
        })
        .then(() => console.log("Shared successfully"))
        .catch((err) => console.log("Share cancelled:", err));
    } else {
      alert("Share not supported on this device");
    }
  };

  const updateTourbooking = (name, value) => {
    setShowPrice(false);
    setpackagepriceData(null);
    handlePackageInputChange(name, value);
  };

  // Handle child age change
  const updateAge = (index, value) => {
    handleAgeChange(index, value);
  };

  const isChildAgeValid = () => {
    if (formData.childCount > 0) {
      const filled = ages.filter((a) => a !== "");

      if (filled.length !== formData.childCount) {
        setAgeError("Please select age for all children");
        alert("Please select age for all children");
        return false;
      }
    }

    setAgeError("");
    return true;
  };

  const handleCalculatePrice = async () => {
    if (!date) {
      alert("Please select travel date");
      return;
    }

    if (!formData.adultCount) {
      alert("Please select number of adults");
      return;
    }

    if (!isChildAgeValid()) return;

    if (priceerrors.total) return;

    setIsDisabled(true);

    try {
      const payload = {
        packageId: formData.packageId,
        adultCount: formData.adultCount,
        childCount: formData.childCount,
        travelDate: date,
        entryFee: needEntryTicket, //  NEW
      };

      const res = await dispatch(carPackagePrice(payload)).unwrap();

      setpackagepriceData(res?.carpackageprice?.data);
      setShowPrice(true);
    } catch (e) {
      console.error(e);
      alert("Failed to calculate price");
    } finally {
      setIsDisabled(false);
    }
  };

  const validateModalForm = () => {
    const newErrors = {};

    if (!name.trim() || !nameregex.test(name)) {
      newErrors.name = "Please enter a valid name";
    }

    if (!contactNumber || !mobileregex.test(contactNumber)) {
      newErrors.contactNumber = "Please enter a valid mobile number";
    }

    if (!email.trim() || !emailregex.test(email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!adult || Number(adult) <= 0) {
      newErrors.adult = "Please enter number of adults";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      <Navbarsticky />
      <section className="tour-hero d-flex justify-content-center align-items-center text-center"></section>
      <div className="container py-4">
        <Row className="align-items-center mb-4">
          <Col md={8}>
            <h2 className="fw-bold text-dark">{packageName}</h2>

            <div className="d-flex flex-wrap align-items-center gap-4 mt-2">
              <div className="text-muted">
                <i className="bi bi-clock text-primary me-1"></i>
                {duration}
              </div>
            </div>
          </Col>

          <Col
            md={4}
            className="text-end d-none d-md-flex align-items-center justify-content-end gap-4"
          >
            <a
              className="text-dark"
              onClick={handleShare}
              style={{ cursor: "pointer" }}
            >
              <i className="bi bi-share me-1"></i>Share
            </a>

            <Button
              type="button"
              variant="primary"
              onClick={() => setIsModalOpen(true)}
              className="take-tour-btn  px-4 py-2"
            >
              Enquire <i className="bi bi-arrow-right ms-2" />
            </Button>
          </Col>

          {/* Mobile Floating Enquire Button */}
          <Button
            className="mobile-enquire-btn d-md-none"
            onClick={() => setIsModalOpen(true)}
          >
            <i className="bi bi-chat-dots-fill"></i>
          </Button>
        </Row>

        <Row>
          {/* LEFT GALLERY */}

          <Col md={9}>
            <Card className="border-0 shadow-sm rounded-4 p-3">
              <Carousel
                activeIndex={activeIndex}
                onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                indicators={false}
                nextIcon={null}
                prevIcon={null}
              >
                {images.map((img, i) => (
                  <Carousel.Item key={i}>
                    <div className="position-relative">
                      <img
                        alt=""
                        src={img.mediaLink}
                        className="w-100 rounded-4"
                        style={{ height: 450, objectFit: "cover" }}
                      />

                      <button
                        className="carousel-control-prev-custom"
                        onClick={() =>
                          setActiveIndex(
                            (i - 1 + images.length) % images.length,
                          )
                        }
                      >
                        <i className="bi bi-arrow-left"></i>
                      </button>

                      <button
                        className="carousel-control-next-custom"
                        onClick={() => setActiveIndex((i + 1) % images.length)}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>

              <div className="d-flex gap-3 mt-3 flex-wrap">
                {images.map((img, idx) => (
                  <img
                    key={idx}
                    src={img.mediaLink}
                    alt=""
                    onClick={() => setActiveIndex(idx)}
                    className={`rounded-4 ${
                      activeIndex === idx ? "thumb-active" : ""
                    }`}
                    style={{
                      width: 120,
                      height: 80,
                      objectFit: "cover",
                      cursor: "pointer",
                      border:
                        activeIndex === idx
                          ? "2px solid #00a6e9"
                          : "2px solid #ddd",
                    }}
                  />
                ))}
              </div>
            </Card>

            {/* ABOUT SECTION */}
            <Card className="p-4 mt-4 shadow-sm border-0 rounded-4">
              <h4 className="fw-bold mb-3">Overview</h4>
              <HTMLRenderer htmlContent={description} />

              <hr />
              <h4 className="fw-bold mb-3">Itinerary</h4>
              <Accordion defaultActiveKey="0" className="custom-accordion">
                {tourIternary?.map((item, index) => (
                  <Accordion.Item eventKey={String(index)} key={index}>
                    <Accordion.Header>
                      <div className="day-badge">
                        Day–{String(index + 1).padStart(2, "0")}
                      </div>

                      <span className="acc-title">{item?.title}</span>
                    </Accordion.Header>

                    <Accordion.Body>
                      <HTMLRenderer htmlContent={item?.description} />

                      {(item.breakfast === 1 ||
                        item.lunch === 1 ||
                        item.dinner === 1) && (
                        <div
                          className="meals-box d-flex flex-wrap gap-2"
                          style={{ marginBottom: "15px" }}
                        >
                          {item.breakfast === 1 && (
                            <span className="meal-tag">
                              <i className="bi bi-cup-hot-fill me-1"></i>
                              Breakfast
                            </span>
                          )}

                          {item.lunch === 1 && (
                            <span className="meal-tag">
                              <i className="bi bi-egg-fried me-1"></i>
                              Lunch
                            </span>
                          )}

                          {item.dinner === 1 && (
                            <span className="meal-tag">
                              <i className="bi bi-moon-stars-fill me-1"></i>
                              Dinner
                            </span>
                          )}
                        </div>
                      )}

                      {item?.ferry?.image && (
                        <div className="ferry-box">
                          <img
                            src={item?.ferry?.image}
                            alt=""
                            style={{
                              width: "120px",
                              borderRadius: "10px",
                              marginBottom: "5px",
                            }}
                          />
                          <p style={{ margin: 0 }}>{item?.ferry?.name}</p>
                        </div>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>

              <hr />
              <h4 className="fw-bold mb-3">Vehicle Price Details</h4>
              <div className="table-responsive shadow-sm rounded-3 border mt-3">
                <table className="table table-bordered table-striped align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Vehicle Name</th>
                      <th>Person</th>
                      <th>Price</th>
                      <th>Entry Fee Price</th>
                    </tr>
                  </thead>

                  <tbody>
                    {vehicleDetails?.map((items, index) => (
                      <tr key={index}>
                        <th>{index + 1}</th>

                        <td>{items.vehicleName}</td>

                        <td>{items.range}</td>

                        <td>{items.price}</td>

                        <td>{items.entryFees}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="included-excluded mt-4">
                <h3 className="fw-bold mb-4">Included</h3>

                <Row>
                  {/* Included */}
                  <Col md={12}>
                    <div className="d-flex align-items-center mb-3">
                      <ol>
                        <li>
                          <strong>Greeting &amp; Assistance</strong> upon
                          arrival at <strong>Port Blair Airport</strong> by our
                          representative.
                        </li>

                        <li>
                          <strong>All-day tours with transfers</strong>,
                          including airport pick-up and drop-off as per
                          itinerary.
                        </li>

                        <li>
                          <strong>Inter-island transfers</strong> to{" "}
                          <strong>Havelock Island / Neil Island</strong> via{" "}
                          <strong>Makruzz or Nautika private cruise</strong>.
                        </li>

                        <li>
                          <strong>Dedicated Personal Tour Coordinator</strong>{" "}
                          as a single point of contact across all islands.
                        </li>

                        <li>
                          <strong>Sightseeing tours as per itinerary</strong>,
                          including all required transfers and airport pick-up
                          &amp; drop-off.
                        </li>

                        <li>
                          <strong>
                            All entry tickets, ferry tickets, and permit charges
                          </strong>{" "}
                          included.
                        </li>

                        <li>
                          <strong>On-ground travel assistance</strong> by our
                          field executives at all major entry and exit points.
                        </li>

                        <li>
                          <strong>
                            Private, dedicated air-conditioned vehicles
                          </strong>{" "}
                          for sightseeing as per itinerary (not at disposal).
                        </li>

                        <li>
                          <strong>GST included</strong> in the package cost.
                        </li>

                        <li>
                          <strong>
                            Sightseeing in private air-conditioned vehicles
                          </strong>{" "}
                          for maximum comfort.
                        </li>

                        <li>
                          <strong>
                            Complete ferry, boat, permit, and entry ticket
                            charges
                          </strong>{" "}
                          wherever applicable in the itinerary.
                        </li>

                        <li>
                          <strong>Daily travel assistance</strong> by our
                          experienced local travel experts throughout the tour.
                        </li>
                      </ol>
                    </div>
                  </Col>
                </Row>
                <h3 className="fw-bold mb-4">Excluded</h3>
                <Row>
                  <Col md={12}>
                    <div className="d-flex align-items-center mb-3">
                      <ol>
                        <li>
                          <strong>Booking reconfirmation</strong> will be done
                          only after receipt of the advance payment.
                        </li>

                        <li>
                          <strong>Passport copies</strong> are mandatory for
                          payments made in foreign currency.
                        </li>

                        <li>
                          <strong>Punctuality is mandatory</strong> for all
                          tours and transfers. Drivers will wait for a maximum
                          of <strong>10 minutes</strong> only.
                        </li>

                        <li>
                          <strong>Camera tickets</strong> must be purchased
                          directly at the respective sightseeing locations.
                        </li>

                        <li>
                          <strong>Medical and travel insurance</strong> is not
                          included in the package.
                        </li>

                        <li>
                          <strong>Vehicle services on leisure days</strong> or
                          sightseeing not mentioned in the itinerary are not
                          included.
                        </li>

                        <li>
                          <strong>Additional tours or vehicle usage</strong>{" "}
                          beyond the mentioned itinerary are excluded.
                        </li>

                        <li>
                          <strong>Any additional expenses</strong> arising due
                          to bad weather, flight or ferry cancellations,
                          strikes, or political unrest are not included.
                        </li>

                        <li>
                          <strong>GST @ 5%</strong> will be applicable and added
                          to the final bill.
                        </li>

                        <li>
                          <strong>Anything not specifically mentioned</strong>{" "}
                          under the “Inclusions” section is excluded.
                        </li>
                      </ol>
                    </div>
                  </Col>
                </Row>
                <hr />
                <h4 className="fw-bold mb-3">Policy</h4>
                <b>Payment Policy</b>
                <p className="text-dark">
                  Payment can be made via wire transfer to the company's bank
                  account in Port Blair. 50% advance payment should be made in
                  order to confirm the booking.
                </p>
                <b>Cancellation Policy</b>
                <p>
                  Notification: You can cancel your holiday anytime, but you
                  must notify the company in writing. Special Occasions (Puja,
                  Valentine’s Day, Christmas, New Year):No cancellations or
                  refunds allowed during these times. Cancellation Fee after
                  Advance Payment: A cancellation charge of ₹2500 per person
                  applies once the advance is paid.
                </p>
                <b>Penalty Fees Based on Timing</b>
                <p>
                  Within 15 days before Arrival: 100% of the package cost is
                  charged as a penalty. 16–20 days before Arrival: 75% of the
                  package cost is charged as a penalty. 21–29 days before
                  Arrival: 50% of the package cost is charged as a penalty. 30
                  or more days before Arrival: 25% of the package cost is
                  charged as a penalty.
                </p>
              </div>
            </Card>

            {/* 
                <h4 className="fw-bold mt-5 mb-3">Customer Reviews</h4>
    
                {reviews.map((rev, i) => (
                  <Card key={i} className="p-4 mb-3 shadow-sm border-0 rounded-4">
                    <Row className="align-items-center">
                      <Col xs={3} md={2} className="text-center">
                        <img
                          src={rev.img}
                          alt=""
                          className="rounded-circle img-fluid"
                          style={{ width: 80, height: 80, objectFit: "cover" }}
                        />
                      </Col>
    
                      <Col xs={9} md={10}>
                        <div className="d-flex justify-content-between">
                          <h6 className="fw-bold">{rev.name}</h6>
                          <div className="text-warning">
                            {[...Array(5)].map((_, idx) => (
                              <i key={idx} className="bi bi-star-fill"></i>
                            ))}
                          </div>
                        </div>
                        <small className="text-muted">{rev.date}</small>
                        <p className="mt-2 text-dark">{rev.text}</p>
                      </Col>
                    </Row>
                  </Card>
                ))} */}
          </Col>

          {/* Tour Booking */}

          <Col md={3}>
            <div className="tour-sticky-sidebar">
              <Card
                id="tour-booking-box"
                className="shadow-sm border-0 rounded-4 p-2"
              >
                <h5 className="fw-bold mb-3">Package Booking</h5>
                <Form>
                  <Form.Group className="mb-3  my-4">
                    <small className="fw-semibold">Travel Date</small>
                    <Form.Control
                      type="date"
                      className="rounded-3 mt-1"
                      value={date}
                      min={today} //  disables previous dates
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mt-3">
                    <Form.Check
                      type="checkbox"
                      id="entryFee"
                      label="Need Entry Ticket"
                      checked={needEntryTicket}
                      onChange={(e) => setNeedEntryTicket(e.target.checked)}
                    />
                  </Form.Group>

                  {/* adult */}

                  <Form.Group className="mb-3 my-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="fw-bold">Adult</span>
                        <br></br>
                        <span className="text-muted ms-1">
                          (Above 12 years)
                        </span>
                      </div>

                      <Form.Select
                        value={formData.adultCount}
                        onChange={(e) =>
                          updateTourbooking(
                            "adultCount",
                            Number(e.target.value),
                          )
                        }
                        style={{ width: "80px" }}
                      >
                        <option></option>
                        {Array.from({ length: 41 }).map((_, i) => (
                          <option key={i} value={i}>
                            {i}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </Form.Group>

                  {/* child */}

                  <Form.Group className="mb-3 my-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="fw-bold">Child</span>
                        <br></br>
                        <span className="text-muted ms-1">
                          (Below 12 years)
                        </span>
                      </div>

                      <Form.Select
                        value={formData.childCount}
                        onChange={(e) =>
                          updateTourbooking(
                            "childCount",
                            Number(e.target.value),
                          )
                        }
                        style={{ width: "80px" }}
                      >
                        <option></option>
                        {Array.from({ length: 41 }).map((_, i) => (
                          <option key={i} value={i}>
                            {i}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </Form.Group>

                  {formData.childCount > 0 && (
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Children Age</Form.Label>

                      <div className="row">
                        {Array.from({ length: formData.childCount }).map(
                          (_, index) => (
                            <div className="col-6 mt-2" key={index}>
                              <Form.Select
                                value={ages[index] || ""}
                                onChange={(e) =>
                                  updateAge(index, e.target.value)
                                }
                              >
                                <option value="">Age</option>
                                {Array.from({ length: 12 }).map((_, a) => (
                                  <option key={a + 1} value={a + 1}>
                                    {a + 1}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          ),
                        )}
                      </div>
                    </Form.Group>
                  )}

                  {priceerrors.total && (
                    <div className="text-danger mt-3">{priceerrors.total}</div>
                  )}

                  <Button
                    className="w-100 mt-3 take-tour-btn  px-4 py-2"
                    onClick={handleCalculatePrice}
                    disabled={!formData.adultCount}
                  >
                    Calculate Price <i className="bi bi-arrow-right ms-2" />
                  </Button>

                  {showPrice && packagepriceData && (
                    <div
                      className="p-2 mt-4 rounded-3"
                      style={{
                        background: "#f8f9fa",
                        border: "1px solid #eee",
                      }}
                    >
                      <div className="d-flex justify-content-between mb-2">
                        <span>Package Price:</span>
                        <strong>₹ {packagepriceData.packageBasePrice}</strong>
                      </div>

                      <div className="d-flex justify-content-between mb-2 text-success">
                        <span>Discount:</span>
                        <strong>- ₹ {packagepriceData.discount}</strong>
                      </div>

                      <div className="d-flex justify-content-between mb-2">
                        <span>Tax:</span>
                        <strong>₹ {packagepriceData.taxAmount}</strong>
                      </div>

                      <hr />

                      <div className="d-flex justify-content-between fs-5">
                        <span>Total:</span>
                        <strong>₹ {packagepriceData.amountPayable}</strong>
                      </div>
                    </div>
                  )}
                </Form>
              </Card>
            </div>
          </Col>
        </Row>
      </div>

      {/* =================== QUICK ENQUIRY POPUP =================== */}

      <Modal
        show={isModalOpen}
        onHide={closeModal}
        size="md"
        centered
        backdrop="static"
        dialogClassName="custom-modal"
      >
        {/* /* HEADER IMAGE */}
        <div className="enq-header">
          <img src={enquiryheadimg} alt="" className="enq-header-img" />

          {/* Wave */}
          <svg
            className="enq-wave"
            viewBox="0 0 500 60"
            preserveAspectRatio="none"
          >
            <path
              d="M0,40 C150,80 350,0 500,40 L500,60 L0,60 Z"
              fill="#ffffff"
            />
          </svg>
        </div>

        <Modal.Body>
          <form onSubmit={submitenquiry}>
            <div className="text-center">
              <h4>Quick Enquiry</h4>
            </div>

            <div className="mb-3 row p-1">
              {/* Name */}
              <div className="col-12 p-2 my-1">
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleInputChange}
                  placeholder="Enter Your Name"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                />
                {errors.name && (
                  <div className="text-danger">{errors.name}</div>
                )}
              </div>

              {/* Mobile */}
              <div className="col-12 p-2 my-1">
                <input
                  type="text"
                  name="contactNumber"
                  value={contactNumber}
                  onChange={handleInputChange}
                  placeholder="Enter Your Mobile Number"
                  className={`form-control ${
                    errors.contactNumber ? "is-invalid" : ""
                  }`}
                />
                {errors.contactNumber && (
                  <div className="text-danger">{errors.contactNumber}</div>
                )}
              </div>

              {/* Email */}
              <div className="col-12 p-2 my-1">
                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder="Enter Your Email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                />
                {errors.email && (
                  <div className="text-danger">{errors.email}</div>
                )}
              </div>

              {/* Adult */}
              <div className="col-4 p-2 my-1">
                <input
                  type="text"
                  name="adult"
                  value={adult}
                  onChange={handleInputChange}
                  placeholder="Adult"
                  className={`form-control ${errors.adult ? "is-invalid" : ""}`}
                />
                {errors.adult && (
                  <div className="text-danger">{errors.adult}</div>
                )}
              </div>

              {/* Child */}
              <div className="col-4 p-2 my-1">
                <input
                  type="text"
                  name="childwithbed"
                  value={childwithbed}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
                    setchildwithbed(val);
                  }}
                  placeholder="Child (5-12 Years)"
                  className="form-control"
                />
              </div>
              <div className="col-4 p-2 my-1">
                <input
                  type="text"
                  name="childwithoutbed"
                  value={childwithoutbed}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
                    setchildwithoutbed(val);
                  }}
                  placeholder="Child (0-5 Years)"
                  className="form-control"
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="enq-actions">
              <button
                type="button"
                className="enq-btn enq-btn-cancel"
                onClick={closeModal}
                disabled={isSubmitting}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="enq-btn enq-btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* Floating Mobile Book Now Button */}
      <div className="floating-book-btn d-md-none">
        <Button
          className="w-100 py-3 fw-bold"
          variant="primary"
          onClick={() => {
            setShowEnquiry(true);
            document
              .getElementById("tour-booking-box")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          BOOK NOW
        </Button>
      </div>
      <Footer />
    </>
  );
}
